export default __webpack_public_path__ + "static/media/moldura.88b5c05b.png";